export default "__VITE_PUBLIC_ASSET__65875ca7__"